module.exports = __webpack_public_path__ + "img/baner-konkurs.28a3ffd0.png";